/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useEffect, useMemo, useState } from 'react';
import { css, jsx } from '@emotion/react';
import Button from '@mui/material/Button';

/* Button used in dashboard and with uploads that is not primary */
export default function BigButton({ title, icon: Icon, ...props }) {
  return (
    <Button
      color="text"
      css={css`
        min-width: 150px;
        height: 105px;
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.23);
        padding: 16px;
        gap: 8px;
        position: relative;
        cursor: pointer;
        transition: background 0.2s;
        box-sizing: border-box;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        flex-direction: column;
        font-size: 15px;

        font-size: 15px;
        font-weight: 600;
        line-height: 22.5px;
        flex-direction: column;
        align-items: flex-start;
        text-wrap: nowrap;
        border-radius: 8px;
        padding: 16px;
        gap: 8px;
      `}
      {...props}
    >
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 40px;
          background: rgba(0, 0, 0, 0.08);
          border-radius: 50%;
        `}
      >
        <Icon />
      </div>
      {title}
    </Button>
  );
}
